export default __webpack_public_path__ + "static/media/icon-solicitar-assistencia.de0ccb30.svg";